import { AppContextProvider } from 'components/organisms/app-context/provider';
import { SetupOkta } from 'components/organisms/authentication/setup-okta';
import './App.css';
import '@rocketlane/rocket-llm/dist/index.css';

export const App = () => {
  return (
    <AppContextProvider>
      <SetupOkta />
    </AppContextProvider>
  );
};
